<template>
  <b-overlay
    :show="loader.planEstudios"
    opacity="0.50"
    rounded="sm"
  >
    Selecciona el Plan de Estudios:
    <v-select
      v-model="idplan"
      :options="ofertaAcademica"
      :reduce="oferta => oferta.id"
      label="nombre"
      value="id"
      filterable
      placeholder="Selecciona"
      :clearable="false"
      @input="(val) => $emit('selectedplan', val)"
    >
      <template #no-options>
        Inhabilitado por el momento.
      </template>
    </v-select>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, onMounted, computed,
} from '@vue/composition-api'
import store from '@/store'

export default {
  components: {
    vSelect,
    BOverlay,
  },
  props: {
    filtrado: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const periodos = ref(null)
    const loader = ref(false)
    const idplan = ref(null)
    const ofertaAcademica = computed(() => store.state.ofertaAcademica.especialidades)

    const getPlanEstudios = () => {
      loader.value = true
      store.dispatch('ofertaAcademica/loadOferta', props.filtrado)
        .then(() => {
          loader.value = false
        }, error => {
          if (error) loader.value = false
        })
    }
    onMounted(() => { getPlanEstudios() })

    return {
      idplan,
      periodos,
      loader,
      ofertaAcademica,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
